import { ArrowDownward, ArrowUpward, Clear, Search } from '@mui/icons-material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { FC } from 'react';

type SearchFieldProps = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortBy: string;
  invert: boolean;
  searchOptions: { name: string; label: string }[];
  onSort: (sortBy: string | undefined, reverse: boolean) => void;
  customTooltip?: { name: string; tooltip: { inverted: string; upright: string } }[];
  autoFocus?: boolean;
};

const SearchField: FC<SearchFieldProps> = ({
  sortBy,
  invert,
  onSort,
  searchQuery,
  setSearchQuery,
  searchOptions,
  customTooltip,
  autoFocus
}) => {
  const getTooltipText = () => {
    let result = invert ? 'Sort Z-A' : 'Sort A-Z';
    customTooltip?.forEach((tooltip) => {
      if (tooltip.name === sortBy) {
        result = invert ? tooltip.tooltip.inverted : tooltip.tooltip.upright;
      }
    });
    return result;
  };

  return (
    <Box display={'flex'} alignItems={'flex-center'} gap={1} pt={1} width='100%'>
      <TextField
        label='Search'
        autoFocus={autoFocus}
        value={searchQuery}
        onChange={(event) => setSearchQuery(event.target.value)}
        InputProps={{
          autoComplete: 'off',
          endAdornment: (
            <InputAdornment position='end'>
              {searchQuery ? (
                <IconButton size='small' onClick={() => setSearchQuery('')}>
                  <Clear />
                </IconButton>
              ) : (
                <Search />
              )}
            </InputAdornment>
          )
        }}
        fullWidth
        size='small'
        sx={{ flexGrow: 1 }}
      />
      <TextField
        value={sortBy}
        select
        size='small'
        label='Sort by'
        onChange={(event) => onSort(event.target.value, false)}
        sx={{ flexGrow: 1, minWidth: '10rem' }}
        InputProps={{ autoComplete: 'off' }}
      >
        {searchOptions.map((option) => (
          <MenuItem key={`option-key-${option.name}`} value={option.name}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <Tooltip title={getTooltipText()} placement='top' arrow>
        <IconButton size='small' onClick={() => onSort(undefined, true)}>
          {invert ? <ArrowUpward /> : <ArrowDownward />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default SearchField;
